var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconPublishLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconPublish",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M960 1807.059c-467.125 0-847.059-379.934-847.059-847.059 0-467.125 379.934-847.059 847.059-847.059 467.125 0 847.059 379.934 847.059 847.059 0 467.125-379.934 847.059-847.059 847.059M960 0C430.645 0 0 430.645 0 960s430.645 960 960 960 960-430.645 960-960S1489.355 0 960 0M854.344 1157.975 583.059 886.69l-79.85 79.85 351.135 351.133L1454.4 717.617l-79.85-79.85-520.206 520.208Z",
      fillRule: "evenodd"
    })));
  }
}
IconPublishLine.glyphName = 'publish';
IconPublishLine.variant = 'Line';
IconPublishLine.displayName = 'IconPublishLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconPublishLine.propTypes = {
  ...SVGIcon.propTypes
};
IconPublishLine.allowedProps = [...SVGIcon.allowedProps];
export default IconPublishLine;
export { IconPublishLine };